module.exports = __webpack_public_path__ + "img/bay-logo.0a4e7a8c.png";